import {
  Box,
  Grid,
  Select,
  MenuItem,
  TextField,
  Typography,
  Button,
  IconButton,
  useTheme,
  Switch,
} from "@mui/material";
import {
  StarOutlined,
  Visibility,
  StarBorder,
  ArrowDropDown,
} from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import OrderPageCard from "../../components/cards/OrderPageCard";
import DynamicTable from "../../components/DynamicTable";
import DashboardTable from "../../components/NewTable/DashboardTable";
import { usePagination } from "../../hooks";
import { $crud } from "../../utils/CrudFactory";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Filter from "../../components/Filter";
import { driverFilters, orderFilters } from "../../utils/filterConfig";
import DriverStatusModal from "../../components/modals/DriverStatusModal";
import DriverVipModal from "../../components/modals/DriverVipModal";
import { timetoUTC, toLocalTime } from "../../helper/functions";
import { socket } from "../../components/notification/Notifications";
import ClientSearch from "../../components/search/clients/ClientSearch";

export default function Drivers() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [newStatus, setNewStatus] = useState(""); // state to open position modal
  const [statusModalOpen, setStatusModalOpen] = useState(false); // state to open position modal
  const [statusPlaceholder, setStatusPlaceholder] = useState(""); // state to open position modal
  const [statusBtn, setStatusBtn] = useState(""); // state to open position modal
  const [statusModalTitle, setStatusModalTitle] = useState(""); //state to display position modal title
  const [selectedRow, setSelectedRow] = useState(null); // To store the selected row for which position is being updated
  const [vipModal, setVipModal] = useState(false); // To store the selected row for which position is being updated
  const [vipRow, setVipRow] = useState(null); // To store the selected row for which position is being updated
  const [isFilter, setIsFilter] = useState(false); //STATE TO GET THE ORDER LIST

  // STATE TO MANAGE FILTERS --------------------------------------
  const [filtrationData, setFiltrationData] = useState({
    from: "",
    to: "",
    amountFrom: "",
    amountTo: "",
    blockStatus: "",
    driverType: "",
    search: "",
  });
  // STATE TO MANAGE FILTERS --------------------------------------
  const [rows, setRows] = useState([]); //STATE TO GET THE ORDER LIST
  const { page, limit, setLimit, setPage, total, setTotal } = usePagination(); // PAGINATION PROPS
  const [search, setSearch] = useSearchParams();

  const searchVal = search.get("search");

  // function to add data in position modal-----------------------------
  const handleStatusChange = (row, newStatus) => {
    setSelectedRow(row);
    setNewStatus(newStatus);
    setStatusModalTitle("Add a reason for this Driver Status Change");
    setStatusPlaceholder("Enter comments for this change");
    setStatusBtn("Change");
    setStatusModalOpen(true);
  };

  // function to close position modal---------------------------------
  const handleCloseModal = () => {
    setStatusModalTitle(false);
    setSelectedRow(null);
    setStatusModalOpen("");
  };

  // function to call the api and update the comment -------------------------------------
  const handleStatusSubmit = async (reason) => {
    // Logic to update position with reason
    const { data, type } = await $crud.put(`admin/driver`, {
      blockStatus: newStatus,
      comment: reason,
      _id: selectedRow._id,
    });
    if (type == "success") {
      retrieveData().then((res) => {
        setRows(res.result);
        setTotal(res.total);
      });
    }
    handleCloseModal();
  };

  // ========================= FUNCTION TO GET THE ORDER DATA FROM DATABASE(calling orders api) =============================
  async function retrieveData() {
    const isFilterApplied = Object.values(filtrationData).some(
      (value) => value !== "" && value !== false
    );

    const params = {
      from: filtrationData.from,
      to: filtrationData.to,
      amountFrom: timetoUTC(filtrationData.amountFrom),
      amountTo: timetoUTC(filtrationData.amountTo),
      blockStatus: filtrationData.blockStatus,
      driverType: filtrationData.driverType,
      search: filtrationData.search || searchVal || "",
      skip: rows.length,
    };

    // Conditionally include limit and page if no filters are applied
    if (!isFilterApplied) {
      params.limit = 0;
      params.page = 0;
    }

    const { data } = await $crud.retrieve("admin/drivers", params);
    return data;
  }
  // ========================= FUNCTION TO GET THE ORDER DATA FROM DATABASE(calling orders api) =============================

  useEffect(() => {
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
    retrieveData().then((res) => {
      setRows(res.result);
      setTotal(res.total);
    });
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
  }, [limit, page, filtrationData, searchVal]);

  // FUNCTION FOR CUSTOM STYLE OF CURRENT STATUS DROPDOWN BUTTONS------------------
  const getStatusStyles = (status) => {
    switch (status) {
      case "Blocked":
        return {
          background: "#FFE6DB",
          color: "rgba(235, 8, 0, 1)",
          fontSize: "12px",
        };
      case "Pending Enrollment":
        return {
          background: "rgba(247, 198, 4, 0.10)",
          color: "rgba(247, 198, 4, 1)",
          fontSize: "12px",
        };
      case "Enrollment Review":
        return {
          background: "rgba(103, 60, 142, 0.35)",
          color: "rgba(103, 60, 142, 1)",
          fontSize: "12px",
        };
      case "Active":
        return {
          background: "rgba(7, 79, 36, 0.20)",
          color: "rgba(7, 79, 36, 1)",
          fontSize: "12px",
        };
      case "Offline":
        return {
          background: "rgba(254, 133, 106, 0.2)",
          color: "rgba(254, 133, 106, 1)",
          fontSize: "12px",
        };
      case "Online":
        return {
          background: "rgba(7, 79, 36, 0.2)",
          color: "rgba(7, 79, 36, 1)",
          fontSize: "12px",
        };
      default:
        return {
          background: "#FFF0ED",
          color: "rgba(254, 133, 106, 1)",
        };
    }
  };
  // FUNCTION FOR CUSTOM STYLE OF CURRENT STATUS DROPDOWN BUTTONS----------------------
  const statusOptions = [
    "Pending Enrollment",
    "Enrollment Review",
    "Active",
    "Blocked",
  ];

  const handleOpenVipModal = (row) => {
    setVipModal(true);
    setVipRow(row);
  };

  const handleCloseVipModal = () => {
    setVipModal(false);
    setVipRow(null);
  };

  const handleVipDriver = async (id, vipDriver) => {
    const { data, type } = await $crud.put("admin/vip-driver", {
      id,
      vipDriver,
    });
    if (type == "success") {
      retrieveData().then((res) => {
        setRows(res.result);
        setTotal(res.total);
      });
    }
  };
  const status = ["Online", "Offline"];
  // COLUMNS IN THE ORDER TABLE-----------------------------
  const driverColumns = [
    {
      id: "driverID",
      label: "Driver ID",
      align: "center",
    },
    {
      id: "joinDate",
      label: "Join Date",
      align: "center",
      renderCell: (row) => {
        return toLocalTime(row.joinDate);
      },
    },
    { id: "name", label: "Driver Name", align: "center" },
    { id: "email", label: "Email ID", align: "center" },
    {
      id: "vipDriver",
      label: "VIP",
      align: "center",
      renderCell: (row) => {
        return (
          <Switch
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#683C8C", // Thumb color when checked
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#683C8C", // Track color when checked
              },
              "& .MuiSwitch-track": {
                backgroundColor: "rgba(104, 60, 140, 0.9)", // Track color when unchecked
              },
            }}
            checked={row.vipDriver}
            // onChange={() => handleVipDriver(row._id, row.vipDriver)}
            onChange={() => handleOpenVipModal(row)}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      id: "location",
      label: "Location",
      align: "center",
      renderCell: (row) => {
        return row.location?.length > 20
          ? row.location.slice(0, 20) + "..."
          : row.location || "NA";
      },
    },
    {
      id: "blockStatus",
      label: "Driver Status",
      align: "center",
      renderCell: (row) => {
        const activeStatus = row.blockStatus;
        const styles = getStatusStyles(activeStatus);

        return (
          <Select
            value={activeStatus}
            sx={{
              borderColor: styles.background,
              background: styles.background,
              color: styles.color,
              border: "none",
              outline: "none !important", // Remove outline
              fontSize: "12px",
              borderRadius: "3px",
              "& .MuiSelect-icon": {
                color: styles.color, // Hide the down arrow icon
              },
              "&:hover": {
                outline: "none !important", // Remove hover outline
                border: "none !important", // Remove hover border
              },
              "&:focus": {
                outline: "none !important", // Remove focus outline
                border: "none !important", // Remove focus border
              },
              "& .MuiSelect-select": {
                paddingRight: "32px !important",
                padding: "8px 10px",
                width: "150px",
                outline: "none !important", // Remove outline from select
                border: "none !important", // Remove border from select
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none !important", // Remove border from outlined input
              },
            }}
            onChange={(e) => handleStatusChange(row, e.target.value)}
          >
            {statusOptions.map((status) => (
              <MenuItem
                key={status}
                value={status}
                sx={getStatusStyles(status)}
              >
                {status}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    { id: "totalOrders", label: "Total Orders", align: "center" },
    {
      id: "isEnrolledforsalesTax",
      label: "Sale Tax",
      align: "center",
      renderCell: (row) => row.isEnrolledforsalesTax,
    },
    {
      id: "status",
      label: "Status",
      align: "center",
      renderCell: (row, handleStatusChange) => {
        const activeStatus = row.status;
        const styles = getStatusStyles(activeStatus);

        return (
          <Button
            sx={{
              borderColor: styles.background,
              background: styles.background,
              color: styles.color,
              padding: "8px 18px",
              textTransform: "capitalize",
              border: "none",
              fontSize: "12px",
              borderRadius: "3px",
              width: "90px",
              outline: "none !important",
              "&:hover": {
                outline: styles.background,
                background: styles.background,
                color: styles.color,
              },
              "&:focus": {
                outline: styles.background,
              },
            }}
          >
            {activeStatus}
          </Button>
        );
      },
    },
    {
      id: "action",
      label: "View",
      align: "center",
      renderCell: (row) => {
        return (
          <IconButton
            sx={{ fontSize: "8px", color: "rgba(104, 60, 140, 1)" }}
            onClick={() =>
              navigate(`/driver-detail`, { state: { selectedDriver: row } })
            }
          >
            <Visibility />
          </IconButton>
        );
      },
    },
  ];
  // COLUMNS IN THE ORDER TABLE-----------------------------

  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  const getFilteredData = (data) => {
    if (!data.blockStatus) data.blockStatus = "";
    if (!data.driverType) data.driverType = "";
    setFiltrationData({
      ...filtrationData,
      ...data,
    });
    setIsFilter(true);
    setPage(0);
    setRows([]);
    setTotal(0);
  };
  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------

  useEffect(() => {
    socket.on("updateDriverOnlineStatus", (updatedDriver) => {
      setRows((rows) =>
        rows.map((obj) => {
          if (obj._id === updatedDriver._id) {
            obj.status = updatedDriver.status;
          }
          return obj;
        })
      );
    });

    return () => {
      socket.off("updateDriverOnlineStatus");
    };
  }, []);

  return (
    <>
      <Grid container sx={{ padding: "0 18px" }}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: "30px",
              // color: "#673C8E",
              color: theme.palette.text.primary,
            }}
          >
            Drivers
          </Typography>
        </Grid>
      </Grid>
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"space-between"}
        px="18px"
        mt={"5px"}
      >
        <ClientSearch
          setFiltrationData={setFiltrationData}
          setRows={setRows}
          setTotal={setTotal}
          placeholder="Search with Driver ID, Driver Name & Email ID"
        />
        <Filter
          onResetFilters={() => {
            setFiltrationData((prev) => ({
              search: prev.search,
              from: "",
              to: "",
              amountTo: "",
              amountFrom: "",
              blockStatus: "",
              driverType: "",
            }));
            setRows([]);
            setTotal(0);
          }}
          onFilterData={getFilteredData}
          type="drivers"
          url="drivers"
          config={driverFilters}
        />
      </Box>

      <DashboardTable
        rows={rows}
        columns={driverColumns}
        loadMore={{
          loadmore: () => {
            retrieveData().then((res) =>
              setRows((rows) => [...rows, ...res.result])
            );
          },
          total,
        }}
        emptyMessage="No drivers yet !"
      />
      {/*========================= CALLING DYNAMIC TABLE COMPONENT TO SHOW THE ORDER LIST IN TABLE ===========================*/}
      {statusModalOpen && selectedRow && (
        <DriverStatusModal
          ifOrder={true}
          open={statusModalOpen}
          title={statusModalTitle}
          onSubmit={handleStatusSubmit}
          onClose={handleCloseModal}
          btnText={statusBtn}
          placeholder={statusPlaceholder}
        />
      )}
      {vipModal && (
        <DriverVipModal
          open={vipModal}
          onSubmit={handleVipDriver}
          onClose={handleCloseVipModal}
          row={vipRow}
        />
      )}
    </>
  );
}
